import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { TrainingItemEvaluationVM } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";

export const educationalAdvisorRetrieveEvaluationsByTrainingItem = createAsyncThunk<
  TrainingItemEvaluationVM[],
  string,
  { extra: Partial<Dependencies> }
>(
  "evaluationsByTrainingItem/educationalAdvisorRetrieveEvaluationsByTrainingItem",
  async (studentId: string, { extra: { educationalAdvisorRepository } }) => {
    return educationalAdvisorRepository!.getEvaluationsByTrainingItem(studentId);
  },
);

export const resetEducationalAdvisorRetrieveEvaluationsByTrainingItem = createAction(
  "evaluationsByTrainingItem/resetEducationalAdvisorRetrieveEvaluationsByTrainingItem",
);
